<template>
  <p>IFC File</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>